<template>
	<v-text-field
		v-model="localSearchString"
		dense
		hide-details
		single-line
		outlined
		class="search-field my-4"
		:placeholder="placeholder || 'Search'"
		prepend-inner-icon="mdi-magnify"
	></v-text-field>
</template>

<script>
export default {
	name: 'AppSearch',
	props: {
		searchString: { type: String },
		placeholder: { type: String },
	},
	computed: {
		localSearchString: {
			get() {
				return this.searchString;
			},
			set(value) {
				this.$emit('update:searchString', value);
			},
		},
	},
	methods: {},
	data: () => ({}),
};
</script>

<style scoped lang="scss">
.search-field {
	$color: var(--placeholder-font-color);
	max-height: 34px;
	&::v-deep {
		color: $color;
		&.v-text-field {
			border-radius: 7px !important;
			font-size: 14px;
			font-weight: 400;
		}
		&.v-text-field .v-input__control .v-input__slot {
			min-height: auto !important;
			display: flex !important;
			align-items: center !important;
		}
		&.v-text-field--outlined > .v-input__control > .v-input__slot {
			min-height: 40px;
		}
		&.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) fieldset {
			border-color: var(--border-color);
		}
		&.v-text-field .v-label {
			font-size: 14px !important;
			font-weight: 400 !important;
			line-height: auto !important;
			height: auto !important;
			top: 8px !important;
		}
		&.v-text-field--enclosed .v-input__prepend-inner {
			margin-top: 6px !important;
		}
		.v-input__icon i {
			color: $color;
			font-size: 16px;
			transform: translate(-2px, -2px);
		}
	}
}
</style>
